//packages
import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
//global components
import MainMenu from '../../_components/MainMenu';
import PageNotFound from '../../_components/PageNotFound';
import PreLoader from "../../_components/PreLoader";
//services
import { menuService } from '../../_services/menu.service';
import { postService } from '../../_services/post.service';
//styles
import './Content.sass';

class Content extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            user: {
              details: {}
            },
            menu: {
              items: []
            },
            topbarMenu: {},
            // content: {},
            notfound: false
        };
    }

    componentDidMount() {
      const user = JSON.parse(localStorage.getItem('user'));
      const slug = this.props.match.params[0];
      if (user && Date.now() < user.expiresAt) {
        this.setState({ 
          user: user
        });
      }else{
        this.setState({ 
          user: {
            details: {}
          }
        });
      }
        
      Promise.allSettled([
        postService.getBySlug(slug).then( 
          content => {
            if(!content){
              this.setState({ notFound: true })
            }else{
              menuService.getMenuByName(content.title).then(menu => this.setState({ menu, content }));
            }
          }
        ),
        menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu }))
      ]).then(() => this.setState({ loading: false }))
    }

    render() {
        const { loading, user, menu, topbarMenu, content, notFound } = this.state;

        return (
            <>
              <PreLoader loading={loading} />
              {!notFound?
              <>
              <MainMenu user={user} menu={menu} topbarMenu={topbarMenu}/>
              <div class="jumbotron page-title py-5">
                 <div class="container"><h1 class="text-white bolder ">{content ? content.title : ''}</h1></div>
			        </div>
              {content &&
              <>
              {content.image ?
              <Container>
              <Row>
                <Col md={3} className="image-border">
                    <Image src={content.image} alt="" className="content-img"/>
                </Col>
                <Col md={9}>
                    <div dangerouslySetInnerHTML={{__html: content.content}} />
                </Col>
              </Row>
              </Container>
              :
              <Container>
              <Row>
                <Col md={12}>
                    <div dangerouslySetInnerHTML={{__html: content.content}} />
                </Col>
              </Row>
              </Container>
              }
              </>
              }
              </>
              :
              <PageNotFound/>
              }
            </>
        );
    }
}

export { Content };